<template>
  <div>
    <ts-page-title
      :title="$t('accessorCertificateRequest.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('accessorCertificateRequest.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-between">
        <a-button type="primary" @click="addNew">
          {{ $t("addNew") }}
        </a-button>
        <div class="tw-justify-end tw-space-x-2">
          <a-input
            v-model="search"
            v-tooltip="$t('accessorCertificateRequest.search')"
            :placeholder="$t('accessorCertificateRequest.search')"
            style="width: 250px"
            class="inline-block"
          />
          <a-button v-tooltip="$t('filter')" @click.prevent="visible = true">
            <i class="fa fa-filter"></i>
          </a-button>
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <!-- <td class="tw-whitespace-nowrap">{{ record.card_number }}</td> -->
            <td class="tw-text-center tw-whitespace-nowrap">
              {{ record.branch.prefix_code }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.fname_en }} {{ record.lname_en }}
            </td>
            <td class="tw-whitespace-nowrap tw-text-center">
              {{ record.sex }}
            </td>
            <td class="tw-whitespace-nowrap">{{ record.phone }}</td>
            <td class="tw-whitespace-nowrap">
              {{ record.level_skill_name }} | LeveL:
              {{ record.skill_level_order }}
            </td>
            <td class="tw-text-center tw-items-center tw-whitespace-nowrap">
              <span class="tw-text-green-500" v-if="record.is_approved">
                <a-icon type="check-circle" class="tw-text-lg" />
              </span>
              <span v-else class="tw-text-red-500">
                <a-icon type="close-circle" class="tw-text-lg" />
              </span>
            </td>
            <td class="tw-text-center tw-whitespace-nowrap">
              {{ record.approved_by }}
            </td>
            <td class="tw-text-center tw-whitespace-nowrap">
              {{ record.approved_date }}
            </td>
            <td class="text-center tw-space-x-3 tw-whitespace-nowrap">
              <a
                v-if="!record.is_approved"
                href="#"
                v-tooltip="$t('accessorCertificateRequest.approved')"
                class="text-primary mr-2"
                @click.prevent="approved(record)"
              >
                <i class="fas fa-check"></i>
              </a>
              <a
                v-if="!record.is_approved"
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a
                  href="#"
                  :disabled="record._deleting"
                  v-if="!record.is_approved"
                >
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
    <a-drawer
      :title="$t('filter')"
      :closable="false"
      :visible="visible"
      :zIndex="1020"
      @close="() => (visible = false)"
      width="300px"
    >
      <div class="mb-3">
        <label class="form-col-label control-label">{{
          $t("testingCenter")
        }}</label>
        <ts-branch-filter @filter="(value) => (branch_id = value)" />
      </div>
    </a-drawer>
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('accessorCertificateRequest.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
      width="900px"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapActions, mapState } from "vuex";
import FromAction from "./form.vue";
export default {
  name: "accessorCertificateRequestIndex",
  components: {
    FromAction,
  },
  data() {
    return {
      loading: false,
      showForm: false,
      visible: false,
      branch_id: [],
    };
  },
  computed: {
    ...mapState("academic/accessorCertificateRequest", [
      "resources",
      "pagination",
    ]),
    search: {
      get() {
        return this.$store.state.academic.accessorCertificateRequest.search;
      },
      set(newValue) {
        this.$store.commit(
          "academic/accessorCertificateRequest/SET_SEARCH",
          newValue
        );
        this.$store.commit(
          "academic/accessorCertificateRequest/RESET_CURRENT_PAGE"
        );
      },
    },
    columns() {
      return [
        // {
        //   name: this.$t("accessorCertificateRequest.cardNumber"),
        //   style: "white-space: nowrap;",
        // },
        {
          name: this.$t("accessorCertificateRequest.testingCenter"),
          style: "text-align:center;width:150px;white-space: nowrap;",
        },
        {
          name: this.$t("accessorCertificateRequest.nameEn"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("accessorCertificateRequest.sex"),
          style: "white-space: nowrap;text-align:center;",
        },
        {
          name: this.$t("accessorCertificateRequest.phone"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("accessorCertificateRequest.levelSkill"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("accessorCertificateRequest.isApproved"),
          style: "text-align:center;width: 150px;white-space: nowrap;",
        },
        {
          name: this.$t("accessorCertificateRequest.approvedBy"),
          style: "text-align:center;width: 150px;white-space: nowrap;",
        },
        {
          name: this.$t("accessorCertificateRequest.approvedDate"),
          style: "text-align:center;width: 150px;white-space: nowrap;",
        },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 5%;white-space: nowrap;",
        },
      ];
    },
  },
  methods: {
    ...mapActions("academic/accessorCertificateRequest", ["approve"]),
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("academic/accessorCertificateRequest/fetch", {
          ...attributes,
          branch_id: this.branch_id,
        })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    addNew() {
      this.showForm = true;
    },
    edit(record) {
      this.$store.commit(
        "academic/accessorCertificateRequest/SET_EDIT_DATA",
        record
      );
      this.showForm = true;
    },
    approved(record) {
      this.$router.push({
        name: "accessor-certificate-approve",
        params: {
          candidate_id: record.candidate_id,
          request_skill_id: record.request_skill_id,
          request_id: record.request_id,
        },
      });
    },
    clearEdit() {
      this.$store.commit(
        "academic/accessorCertificateRequest/SET_EDIT_DATA",
        {}
      );
      this.showForm = false;
      this.fetchData();
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch(
          "academic/accessorCertificateRequest/destroy",
          record.request_id
        )
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value });
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("academic/accessorCertificateRequest/RESET_STATE");
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
};
</script>
